import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DATE_RANGE, TDateRange, TDateRangeSliceState } from "../mapTypes";
import { RootState } from "../../../core/store";

const initialState: TDateRangeSliceState = {
    dateRangeData: null,
    dateRangeLoading: false,
    dateRangeError: null,
};

const defaultActivityDateRangeSlice = createSlice({
    name: DATE_RANGE,
    initialState,
    reducers: {
        getDefaultActivityDateRangeRequestAction: (state: TDateRangeSliceState, _: PayloadAction) => {
            state.dateRangeLoading = true;
            state.dateRangeError = null;
        },
        getDefaultActivityDateRangeSuccessAction: (
            state: TDateRangeSliceState,
            { payload: data }: PayloadAction<TDateRange>,
        ) => {
            state.dateRangeLoading = false;
            state.dateRangeData = data;
            state.dateRangeError = null;
        },
        getDefaultActivityDateRangeErrorAction: (
            state: TDateRangeSliceState,
            { payload: error }: PayloadAction<any>,
        ) => {
            state.dateRangeData = null;
            state.dateRangeLoading = false;
            state.dateRangeError = {
                message: (error.response && error.response.data) || error.message || '',
                name: error.name,
                stack: error.stack,
            };
        },
    },
});

export const { getDefaultActivityDateRangeRequestAction, getDefaultActivityDateRangeSuccessAction, getDefaultActivityDateRangeErrorAction } =
    defaultActivityDateRangeSlice.actions;

export default defaultActivityDateRangeSlice.reducer;

export const selectDefaultActivityDateRange = (state: RootState) => state.defaultActivityDateRangeSlice.dateRangeData!;
export const selectDefaultActivityDateRangeLoading = (state: RootState) => state.defaultActivityDateRangeSlice.dateRangeLoading;